<template>
  <div>
    <DxPopup
      id="dx-dialog"
      height="100vh"
      width="100vw"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      @hidden="$emit('hidden')"
    >
      <template #title>
        <div class="work-detail-header">
          <div class="left_side" @click="buttonCloseEvent">
            <img src="@/assets/images/icons/arrow-back.svg" />
            <span>Înapoi</span>
          </div>
          <div class="right_side">
            <img
              src="@/assets/images/icons/dialog-close.svg"
              @click="buttonCloseEvent"
            />
          </div>
        </div>
      </template>
      <template #content>
        <div class="work-detail-container">
          <div class="title-container">
            <img class="title-image" src="@/assets/images/icons/droplet-simple-green.svg" alt="Articole" />
            <div class="title-text">{{work_name}}</div>
            <div class="subtitle-text">{{work_date}}</div>
          </div>
          <div class="title_separator"></div>
          <DxScrollView class="work-detail-scrollable-container" :use-native="false" :bounce-enabled="true" :element-attr="scrollAttributes">
            <div>
              <div class="work-container" v-for="(tractor, t_index) in workDetailsResult" :key="t_index">
                  <div v-if="tractor.related_work" class="related-work-details-heading">
                    <span>{{ $t(tractor.relationship_direction === 'supports' ? 'tools.special_cases.serves_works' : 'tools.special_cases.supporting_works') }}</span>
                    <h3>{{ tractor.work_name }}</h3>
                    <div>{{ tractor.work_date }}</div>
                  </div>
                  <div class="machine-container">
                    <img class="machine-image" src="@/assets/images/icons/oameni.svg" alt="Zilieri" v-if="tractor.machine_name == 'ZILIER_MACHINE'" />
                    <img class="machine-image" src="@/assets/images/icons/tractor.svg" alt="Tractor" v-else />
                    <div class="machine-number" v-if="group_by === 'culture'">{{tractor.culture ? tractor.culture.name : 'Necunoscut' }}</div>
                    <div class="machine-number" v-else-if="group_by === 'employee'">{{tractor.employee ? tractor.employee.name : 'Necunoscut' }}</div>
                    <div class="machine-number" v-else>{{tractor.machine_name == 'ZILIER_MACHINE' ? 'Zilieri(' + tractor.datallers_count + ')' : tractor.machine_name}}</div>
                    <div class="machine-line"></div>
                  </div>
                  <div class="utility-container" v-if="(group_by === 'culture' || group_by === 'employee' || group_by === 'work') && tractor.equipments && tractor.equipments.length > 0">
                    <img class="utility-image" src="@/assets/images/icons/utilaj.svg" alt="Utilaj" />
                    <div class="utility-text">{{tractor.equipments.map(e => e.name).join(', ')}}</div>
                  </div>
                  <div class="culture-container" v-if="tractor.cultures && tractor.cultures.length > 0">
                    <img class="culture-image" src="@/assets/images/icons/culture.svg" alt="Cultura" />
                    <div class="culture-text">{{tractor.cultures.join(', ')}}</div>
                  </div>
                  <div class="culture-container" v-if="group_by === 'work' && tractor.employees && tractor.employees.length > 0">
                    <img class="culture-image" src="@/assets/images/icons/oameni.svg" alt="Employee" />
                    <div class="culture-text">{{tractor.employees.map(e => e.name).join(', ')}}</div>
                  </div>

                  <div class="parcel-container">
                    <img class="parcel-image" src="@/assets/images/icons/parcel2.svg" alt="Parcele" />
                    <div class="parcel-text">
                      <span v-for="(parcelItem, parcelIndex) in tractor.parcel_names" :key="`parcel-${parcelItem.uuid || parcelIndex}`">
                        <template v-if="parcelItem.parcel_names_for_group.length === 0">
                          <span>{{ parcelItem.name }}</span>
                          <span class="parcel-text-light" v-if="parcelItem.season_name">({{ parcelItem.season_name }})</span>
                        </template>
                        <template v-else>
                          <span>{{ parcelItem.name }} (</span>
                          <span v-for="(groupParcel, groupParcelIndex) in parcelItem.parcel_names_for_group" :key="`group-parcel-${groupParcel.name}-${groupParcelIndex}`">
                            <span>{{ groupParcel.name }}</span>
                            <span class="parcel-text-light" v-if="groupParcel.season_name">({{ groupParcel.season_name }})</span>
                            <span v-if="groupParcelIndex < parcelItem.parcel_names_for_group.length - 1">, </span>
                          </span>
                          <span>)</span>
                        </template>
                        <span v-if="parcelIndex < tractor.parcel_names.length - 1"> / </span>
                      </span>
                    </div>
                  </div>
                  <div class="products-container" v-if="tractor.batch_items && tractor.batch_items.length > 0">
                    <div class="products-text">
                      <div v-for="(batch, b_idx) in tractor.batch_items" :key="b_idx">
                        <img class="products-image m-2 drop-img" src="@/assets/images/icons/droplet-simple-green.svg" alt="Produse" />
                        <span class="ml-5">{{batch.product_name}}</span>
                        <span class="products-text-light">({{parseFloat(batch.dose_per_ha).toFixed(3)}} {{batch.mu}}/ha, total cantitate {{ parseFloat(batch.parcel_quantity).toFixed(2) }} {{batch.mu}})</span>
                        ({{ batch.parcels.join(', ') }})
                        <div class="nr" v-if="batch.nr_lot">Nr. Lot: {{batch.nr_lot }}</div>
                        <div class="nr" v-if="batch.nr_tank">Nr. Tanc: {{ batch.nr_tank }}</div>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="cost-container">
                    Cost materiale de input (ron): {{(parseFloat( tractor.batch_cost)).toFixed(2)}}
                  </div>
                  <div class="cost-container">
                    Cost lucrari (ron): {{(parseFloat( tractor.work_cost)).toFixed(2)}}
                  </div>
                  <div class="cost-container">
                    Cost total general (ron): {{(parseFloat( tractor.batch_cost) + parseFloat(tractor.work_cost) + parseFloat(tractor.datallers_salary) ).toFixed(2)}}
                  </div>
                <div class="work-notes" v-if="tractor.notes && tractor.notes.length > 0">
                  <p>Observații</p>
                  {{tractor.notes.join(', ')}}
                </div>
                <!-- <WorkRelationships :relationships="tractor.work_relationships" /> -->
              </div>
            </div>
          </DxScrollView>
        </div>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { mapGetters, mapActions } from "vuex";
// import WorkRelationships from "../partials/WorkRelationships.vue";

export default {
  name: "WorkDetails",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
   work_uuid: {
      type: String,
      default: "",
    },
     work_name: {
      type: String,
      default: "",
    },
    work_date: {
      type: String,
      default: "",
    },
    group_by: {
      type: String,
      default: "work",
    },
    parcel_uuid: {
      type: String,
      default: "",
    },
    parcel_group_parcel_uuids: {
      type: Array,
      default: () => [],
    },
    department_uuid: {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      workDetailsResult: [],
      scrollAttributes: {
                class: 'work-details-scroll'
            },
    };
  },
  components: {
    // WorkRelationships,
    DxPopup,
    DxScrollView,
  },
  computed: {
     ...mapGetters({
      currentDepartment: "auth/currentDepartment",
    }),

  },
  watch: {
    showPopup(newVal){
      if(newVal){
          this.getSpcWorkDetails({
            //department_uuid: this.currentDepartment.department_uuid,
            department_uuid:this.department_uuid,
            work_uuid: this.work_uuid,
            work_date: this.work_date,
            parcel_uuid: (this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0) ? this.parcel_group_parcel_uuids.join() : this.parcel_uuid,
            group_by: this.group_by,
          }).then(response => {
            this.workDetailsResult = [];

            this.buildDetailGroups(response).forEach(({ records: element, related = false, direction = "" }) => {

              let tractorInfo = {
                parcel_names: [],
                equipments: [],
                cultures: [],
                employees: [],
                batch_items: [],
                batch_cost: 0,
                work_cost: 0,
                datallers_count: 0,
                datallers_salary : 0,
                notes: [],
                nr_lot: '',
                nr_tank: '',
                work_relationships: [],
                related_work: related,
                relationship_direction: direction,
                work_name: element[0]?.work?.name || "",
                work_date: element[0]?.work_date || "",
              } ;
              if(element.length > 0){
                tractorInfo.machine_uuid = element[0].machine.uuid;
                tractorInfo.machine_name = element[0].machine.registration_number ? element[0].machine.registration_number : element[0].machine.name;
                tractorInfo.datallers_count = element[0].datallers_count;
                tractorInfo.culture_uuid = element[0].culture_uuid;
                tractorInfo.culture = element[0].culture;
                tractorInfo.employee = element[0].employee;
                tractorInfo.employee_uuid = element[0].employee_uuid;

                if (this.parcel_uuid && !related) {
                  //single parcel cost
                  tractorInfo.datallers_salary = element[0].dataller_total_salary;
                  tractorInfo.work_cost = element[0].work_cost;
                } else {
                  //sum cost
                  let cost = 0;
                  Object.assign([], element).map((el) => {
                    cost += parseFloat(el.dataller_total_salary);
                  });
                  tractorInfo.datallers_salary = cost.toFixed(2);

                  //sum work cost
                  let work_cost = 0;
                  Object.assign([], element).map((el) => {
                    work_cost += parseFloat(el.work_cost);
                  });
                  tractorInfo.work_cost = work_cost.toFixed(2);
                }

                element.forEach(parcel => { // CREATE PARCEL LIST
                  tractorInfo.work_relationships.push(...(parcel.work_relationships || []));
                  let notes_check = tractorInfo.notes.find(obj => obj == parcel.notes);
                   if(notes_check === undefined) {
                    tractorInfo.notes.push(parcel.notes);
                  }

                  let parcel_group_uuid = parcel.parcelGroup?.uuid ?? null;
                  if(parcel_group_uuid){
                    let check_parcel_group = tractorInfo.parcel_names.find(obj => obj.parcel_group_uuid == parcel_group_uuid);
                    if(check_parcel_group === undefined){
                      tractorInfo.parcel_names.push({
                        uuid: parcel.parcel.uuid,
                        name: parcel.parcelGroup.name,
                        parcel_group_uuid: parcel_group_uuid,
                        parcel_names_for_group: [{
                          name: parcel.parcel.name,
                          season_name: parcel.parcel.season_name,
                        }],
                      });
                    } else {
                      if (!check_parcel_group.parcel_names_for_group.some(groupParcel => groupParcel.name === parcel.parcel.name)) {
                        check_parcel_group.parcel_names_for_group.push({
                          name: parcel.parcel.name,
                          season_name: parcel.parcel.season_name,
                        });
                      }
                    }
                  }
                  else{
                    let check_parcel = tractorInfo.parcel_names.find(obj => obj.uuid == parcel.parcel.uuid);
                    if(check_parcel === undefined) {
                      tractorInfo.parcel_names.push({
                        uuid: parcel.parcel.uuid,
                        name: parcel.parcel.name,
                        season_name: parcel.parcel.season_name,
                        parcel_group_uuid: parcel_group_uuid,
                        parcel_names_for_group: [],
                      });
                    }
                  }

                  if(parcel.equipments && parcel.equipments.length > 0){
                    parcel.equipments.forEach(equip => {
                      let check_equip = tractorInfo.equipments.find(obj => obj.uuid == equip.uuid);
                      if(check_equip === undefined){
                        tractorInfo.equipments.push(equip);
                      }
                    });
                  }

                  if(parcel.employee){
                    let check_employee = tractorInfo.employees.find(obj => obj.uuid == parcel.employee.uuid);
                    if(check_employee === undefined){
                      tractorInfo.employees.push(parcel.employee);
                    }
                  }

                  parcel.batch_item.forEach(batch => { //CREATE BATCH ITEMS
                    let check_batch =  tractorInfo.batch_items.find(obj => obj.product_uuid == batch.product_uuid);

                    if(check_batch === undefined){
                      let parcels = [];
                      Object.assign([], element.filter((e => {
                        return Object.assign([], e.batch_item).map((b) => {
                          if (b.product_uuid == batch.product_uuid) {
                            return b;
                          }
                        }).map((item) => {
                          if (item) {
                            parcels.push(e.parcel.name);
                          }
                        });
                      })));
                      tractorInfo.batch_cost = Number.parseFloat(tractorInfo.batch_cost) + Number.parseFloat(batch.total_price);

                      tractorInfo.batch_items.push({
                        product_uuid: batch.product_uuid,
                        product_name: batch.product_name,
                        dose_per_ha: batch.dose_per_ha,
                        mu: batch.measure_unit.name,
                        price: batch.total_price,
                        quantity: Number.parseFloat(batch.quantity).toFixed(2),
                        net_surface_worked: parcel.net_surface_worked,
                        parcel_quantity: batch.stock == 1 ? batch.quantity : (batch.dose_per_ha*parcel.net_surface_worked).toFixed(2),
                        parcel_name: parcel?.parcel?.name,
                        nr_lot: batch.nr_lot,
                        nr_tank: batch.nr_tank,
                        parcels: parcels,
                      });
                    }
                    else{
                      if(batch.stock == 1){
                        tractorInfo.batch_cost = Number.parseFloat(tractorInfo.batch_cost) + Number.parseFloat(batch.total_price);
                        check_batch.price = Number.parseFloat(check_batch.price) + Number.parseFloat(batch.total_price);
                      }               
                      check_batch.parcel_quantity =  Number.parseFloat(check_batch.parcel_quantity) +  Number.parseFloat(batch.dose_per_ha*parcel.net_surface_worked);
                    }
                  });
                })
              }
              this.workDetailsResult.push(tractorInfo);
            });

          });
      }
    }
  },
  methods: {
    buildDetailGroups(response) {
      const groups = response.map((records) => ({ records }));
      const relatedGroups = new Map();
      const seen = new Set();
      response.forEach((records) => records.forEach((record) => {
        (record.related_work_details || []).forEach(({ direction, work }) => {
          if (!work?.uuid) return;
          const identity = `${direction}:${work.uuid}`;
          if (seen.has(identity)) return;
          seen.add(identity);
          const groupUuid = this.group_by === "culture" ? work.culture_uuid
            : this.group_by === "employee" ? work.employee_uuid : work.machine_uuid;
          const key = JSON.stringify([direction, work.work?.uuid, work.work_date, groupUuid]);
          if (!relatedGroups.has(key)) relatedGroups.set(key, { records: [], related: true, direction });
          relatedGroups.get(key).records.push(work);
        });
      }));
      return groups.concat(Array.from(relatedGroups.values()));
    },
     ...mapActions({
      getSpcWorkDetails: "seasonOnParcelHasCulture/getSpcWorkDetails"
    }),
    buttonCloseEvent() {
      this.$emit("hidden");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/digitalAgenda/daBatchProductList.scss";
@import "@/assets/scss/digitalAgenda/daWorkDetails.scss";

.drop-img {
  position: relative;
  top: -2px;
}

.nr {
  padding-left: 10px;
}
.related-work-details-heading {
  border-top: 1px solid #cfd9d5;
  padding: 18px 16px 0;
  color: #565656;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.related-work-details-heading h3 {
  margin: 6px 0;
  color: #323232;
  font-size: 18px;
  font-weight: 700;
}
</style>
